import React from 'react';
import {useAuth} from "../../services/AuthProvider";
import {useNavigate} from "react-router-dom";
import styles from "../StartGame/StartGame.module.css";
import {Grid} from "@mui/material";

import IOSDownloadImage from "../../resources/Footer/Download_on_the_App_Store_Badge_.png";
import AndroidDownloadImage from "../../resources/Footer/google-play-badge_.png";
import LoginRequiredPage from '../ErrorPages/LoginRequiredPage';

const StartGame: React.FC = () => {
  const { isIPBlocked, isLoggedIn, userProfile } = useAuth();
  const navigate = useNavigate();
  const SPARXVersion = (!!isIPBlocked || !!userProfile?.habitsId) ? 'SPARX1' : 'SPARX2';

  return (
    !isLoggedIn ? <LoginRequiredPage /> :
      <div data-testid="StartGame" className={styles.StartGame}>
        <section id="StartGameWelcome" className={styles.StartGameWelcome} style={{padding: '0 15px'}}>
          <Grid container alignItems='center'>
            <Grid item xs={12} md={6} className={styles.StartGameStarContainer}>
              &nbsp;
            </Grid>
            <Grid item xs={12} md={6}>
              <div className={styles.StartGameUserOptions}>
                <div>
                  <h2>Welcome {userProfile?.username}</h2>
                  <p><span style={{fontSize: '18px'}}>You're signed in. Are you ready to play SPARX?</span></p>
                </div>
                <div>
                  <p><button className={`PrimaryButton ${styles.StartGameStartButton}`} onClick={() => navigate("/startsparx")}>Start here</button></p>
                  <p>
                    <span style={{fontSize: '18px'}}>You can also play SPARX on your mobile:</span>
                    <br/>
                    <a target="_blank" rel="noopener noreferrer" href={SPARXVersion === 'SPARX1' ? process.env.REACT_APP_SPARX_GAME_APP_STORE : process.env.REACT_APP_SPARX_GAME_APP_STORE2}>
                      <img src={IOSDownloadImage} alt="Apple store" className={styles.StartGameAppStoreButtons} />
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href={SPARXVersion === 'SPARX1' ? process.env.REACT_APP_SPARX_GAME_PLAY_STORE :  process.env.REACT_APP_SPARX_GAME_PLAY_STORE2}>
                      <img src={AndroidDownloadImage} alt="Andriod play store" className={styles.StartGameAppStoreButtons} />
                    </a>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </section>
      </div>
  );
};

export default StartGame;
